// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload,{
  error:'../static/images/lazyLoad.png',
  loading: '../static/images/lazyLoad.png'
})
import unit from './util/unit'
Vue.use(unit);
/*import Alert from './plugins/alert'
Vue.use(Alert);
import Confirm from './plugins/confirm'
Vue.use(Confirm);
import Toast from './plugins/toast'
Vue.use(Toast);*/
import myPlugins from './plugins/index'
Vue.use(myPlugins);
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

import vuePicturePreview from './util/vue-picture-preview'
/*import vuePicturePreview from 'vue-picture-preview'*/
Vue.use(vuePicturePreview)
//import loading from './util/vue-loading/index'
//Vue.use(loading);

import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
import store from './store'

import VueScroller from 'vue-scroller'
Vue.use(VueScroller);
//Vue.config.devtools = true;
/* eslint-disable no-new */
//Vue.config.devtools = true;
import cryptoUtil from 'cryptoUtil'
Vue.prototype.$cryptoUtil=cryptoUtil;
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js